import React, { useCallback, useState } from "react";
import styles from "./Onboarding.module.scss";
import ClientDetails from "./Client/ClientDetails";
import { Stepper, Step } from "@progress/kendo-react-layout";
import MatterDetails from "./MatterDetails/MatterDetails";
import ConflictCheck from "../../pages/CaseFile/ConflictCheck";
import { RiskAssessment } from "components/RiskAssessments";
import EngagementLetters from "./EngagementLetters/EngagementLetters";
import Tasks from "pages/CaseFile/ClientServices/Tasks";
import OpenMatter from "./OpenMatter/OpenMatter";
import whiteCheck from "assets/whiteCheck.svg";
import { Button } from "@progress/kendo-react-buttons";

const Onboarding = () => {
  const steps = [
    { label: "Client", component: ClientDetails, completed: false },
    { label: "Matter", component: MatterDetails, completed: false },
    { label: "Conflict Check", component: ConflictCheck, completed: false },
    {
      label: "Risk Assessment Client",
      component: RiskAssessment,
      completed: false,
      selectedView: "client",
      type: "OnBoarding",
    },
    {
      label: "Risk Assessment Matter",
      component: RiskAssessment,
      completed: false,
      selectedView: "matter",
      type: "OnBoarding",
    },
    {
      label: "Engagement Letter",
      component: EngagementLetters,
      completed: false,
    },
    { label: "Client Tasks", component: Tasks, completed: false },
    { label: "Opening Matter", component: OpenMatter, completed: false },
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [stepStatus, setStepStatus] = useState(steps);
  const [handlefn, setHandlefn] = useState(null);

  const CurrentComponent = steps[currentStep].component;

  const CustomStep = (props) => {
    const isActive = props.index === currentStep;
    return (
      <Step {...props} className="bg-white">
        <div
          key={props.index}
          className={`${styles.step} ${isActive ? styles.active : ""} ${
            stepStatus[props.index].completed ? styles.completed : ""
          }`}
        >
          <div className={styles.stepContent}>
            <span className={styles.stepNumber}>
              {isActive || stepStatus[props.index].completed ? (
                <img src={whiteCheck} height={12} width={12} alt="whiteCheck" />
              ) : (
                ""
              )}
            </span>
            <span className={styles.stepLabel}>{steps[props.index].label}</span>
          </div>
        </div>
      </Step>
    );
  };

  const moveNext = useCallback(
    (e, data) => {
      if (data) {
        setFormData((prevData) => ({
          ...prevData,
          ...data,
        }));

        setStepStatus((prevStatus) =>
          prevStatus.map((step, index) =>
            index === currentStep ? { ...step, completed: true } : step
          )
        );
      }

      if (e.value === undefined) {
        if (currentStep < steps.length - 1) {
          setCurrentStep(currentStep + 1);
          return;
        }
      } else {
        if (stepStatus[e.value - 1]?.completed || e.value === 0) {
          setCurrentStep(e.value);
        }
      }
    },
    [currentStep, stepStatus]
  );

  return (
    <div className={styles.onboardingVertical}>
      <div className={`shadow-sm ${styles.verticalComponentContainer}`}>
        <div className={styles.sidebar}>
          <Stepper
            orientation="vertical"
            className={styles.verticalStepper}
            value={currentStep}
            onChange={moveNext}
            items={steps}
            item={CustomStep}
          />
        </div>
        <div
          className={`${styles.contentContainer} d-flex flex-column justify-content-between h-100 `}
          style={{ width: "100%" }}
        >
          <CurrentComponent
            moveNext={moveNext}
            formData={formData}
            setHandlefn={setHandlefn}
            selectedView={steps[currentStep].selectedView}
            fromClientOnBoarding={true}
          />
          {currentStep !== 3 && currentStep !== 4 && (
            <div
              className={`mx-3 px-3 pb-5 rounded-3 border border-1 border-bottom-0 border-light shadow-sm`}
              style={{
                height: "55px",
                boxShadow: "0 0 16px rgba(44, 62, 80, 0.07);",
              }}
            >
              <Button
                className="mt-2 common-btn"
                style={{ float: "right" }}
                onClick={handlefn}
              >
                Next
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
